import { useMemo } from 'react';
import moment from 'moment';

const defaultShownProgramsCount = 25;

export default function useFilteredPrograms({
  programs,
  activeTab,
  showAllPrograms,
  programFilters,
}) {
  return useMemo(() => {
    // Each filter returns true if the program passes the filter
    const filters = [
      (program) => {
        // Tab filter
        if (!program.isLive && activeTab === 'Not Live') return true;
        if (
          program.isLive &&
          activeTab === 'Live' &&
          moment(program.startDate).add(1, 'days') > moment()
        )
          return true;
        if (
          program.isLive &&
          activeTab === 'Past' &&
          moment(program.startDate).add(1, 'days') < moment()
        )
          return true;
        return false;
      },
      (program) => {
        // Code filter
        if (!programFilters.code) return true;
        return program.code
          ?.toLowerCase()
          .includes(programFilters.code.toLowerCase());
      },
      (program) => {
        // Branch filter
        const ids = programFilters.branchIds;
        if (!ids || ids.length === 0) return true;
        return ids.some((branch) => branch.value === program.branchId);
      },
      (program) => {
        // Start Date Month filter
        if (!programFilters.startDateMonth) return true;
        const filterMonth = moment(programFilters.startDateMonth).format(
          'YYYY-MM',
        );
        const programMonth = moment(program.startDate).format('YYYY-MM');
        return filterMonth === programMonth;
      },
      (program) => {
        // Start Time filter
        if (!programFilters.startTime) return true;
        return program.startTime === programFilters.startTime;
      },
      (program) => {
        // Study Method filter
        const ids = programFilters.studyMethodIds;
        if (!ids || ids.length === 0) return true;
        return ids.some((m) => m.value === program.study_methodId);
      },
      (program) => {
        // Study Schedule filter
        const ids = programFilters.studyScheduleIds;
        if (!ids || ids.length === 0) return true;
        return ids.some((s) => s.value === program.study_scheduleId);
      },
    ];

    const filteredProgramsResult = programs.filter((program) =>
      filters.every((fn) => fn(program)),
    );

    const result = {
      totalPrograms: filteredProgramsResult.length,
    };

    return {
      ...result,
      filteredPrograms: showAllPrograms
        ? filteredProgramsResult
        : filteredProgramsResult.slice(0, defaultShownProgramsCount),
    };
  }, [programs, activeTab, showAllPrograms, programFilters]);
}
